import { z } from "zod";

export const createSentHomeRequestSchema = z.object({
  description: z.string().min(1, "Please describe why you were sent home"),
  workplaceRepresentativeName: z
    .string()
    .min(1, "Please fill in the name of the workplace representative"),
});

export type CreateSentHomeRequestFormValues = z.infer<typeof createSentHomeRequestSchema>;
